import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";
import CboSeccion from "./CboSeccion";

var inseccion = 0;
const VarSecciones = ({ grupo, grusu }) => {


  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")
  const [descrip, setDescrip] = useState("")
  const [grupoLocal, setGrupoLocal] = useState(0)
  const [empresa, setEmpresa] = useState(0)
  const [seccion, setSeccion] = useState(0)
  const [secciones, setSecciones] = useState([])



  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)


  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */


  useEffect(() => {
    setGrupoLocal(grupo);
  });

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupoLocal;
    consulta.empresa = empresa;
    consulta.seccion = inseccion;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/var/allsecciones`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {
        json3 = data.data;
        setSecciones(json3);
        // si hay datos, cargar en la ficha el primero
        if (json3.length) {
          setNombre(json3[0].Vse_Nombre);
          setDescrip(json3[0].Vse_Descrip);
        }
        console.log("Vars Sección", json3);

      })

  }, [grupoLocal, empresa, seccion]);

  function refresh() {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.seccion = inseccion;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/var/allsecciones`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {
        console.log("si1", data);
        json3 = data.data[0];
        setSecciones(json3);
        // si hay datos, cargar en la ficha el primero
        if (json3.length) {
          console.log("si2", json3);
          setNombre(json3[0].Vse_Nombre);
          setDescrip(json3[0].Vse_Descrip);
        }
        console.log("Vars Sección", json3);

      })


  };




  const handleGoSeccion = (index, event) => {
    setNombre(secciones[index].Vse_Nombre);
    setDescrip(secciones[index].Vse_Descrip);
  }


  const handleGrupoChange = (event) => {
    setGrupoLocal(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };

  const handleSeccionChange = (event) => {
    setSeccion(event.target.value);
    inseccion = event.target.value;
    //refresh();
  };


  /* Save */
  async function handleSave(e) {
    // validar ???

    // llamo a la grabación del registro de alumno

    let unAlumno = new Object();
    unAlumno.codigo = codigo;
    unAlumno.nombre = nombre;
    unAlumno.seccion = seccion;

    //        addAlumno(unAlumno);

    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unAlumno);
      console.log(json);
      if (codigo) {
        url = `${process.env.REACT_APP_API_URL}/alu/update`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/alu/addnew`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data.data;
          console.log(json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

          /* toast */
          setTextoToast("Alumno guardado");
          setShowToast(true);


        })
    } catch (error) {
      console.log(error);

    }



  }

  async function handleNew(e) {
    setCodigo("");
    setNombre("");
    setDescrip("");

    setNotEditable(false);
  }


  async function handleCancel(e) {
    setCodigo("");
    setNombre("");
    setDescrip("");

    setNotEditable(true);

  }

  /* Editar */
  async function handleEdit(e) {
    e.preventDefault()
    try {

      setNotEditable(false);
    } catch (error) {
      console.log(error);

    }

  }

  return (
    <div >




      <div className="container-fluid">
        <h3>Variables de Sección</h3>
        <div className="row">


          <div className="col-xs-12 col-lg-10 col-sm-10 col-md-10">
            <form>

              <div className="row align-items-end">

                <CboGrupo
                  selectedValue={grupo}
                  onChange={handleGrupoChange}
                  disabled={noteditable}
                  grusu={grusu}
                />

                <CboEmpresa
                  selectedValue={empresa}
                  onChange={handleEmpresaChange}
                  disabled={noteditable}
                  grupo={grupo}
                  grusu={grusu}
                />

                <CboSeccion
                  selectedValue={seccion}
                  onChange={handleSeccionChange}
                  disabled={false}
                  grupo={grupo}
                  empresa={empresa}
                />

                <div className="col-lg-2 col-sm-6">

                  <div className="form-group">

                    <label className="l">
                      Nombre
                    </label>

                    <input
                      type="text"
                      className="input-select"
                      placeholder="Nombre de variable"
                      onChange={e => setNombre(e.target.value)}
                      value={nombre}
                      disabled={noteditable}
                    />

                  </div>

                </div>

                <div className="col-lg-3 col-sm-6">

                  <div className="form-group">

                    <label className="l">
                      Descripción
                    </label>

                    <input
                      type="text"
                      className="input-select"
                      placeholder="Descripción"
                      onChange={e => setDescrip(e.target.value)}
                      value={descrip}
                      disabled={noteditable}
                    />

                  </div>

                </div>

                <div className="col-lg-1 col-sm-4">

                  <div className="form-group">

                    <label className="l d-block">
                      Activo
                    </label>

                    <input
                      type="checkbox"
                      checked={activo}
                      disabled={true}
                    />

                  </div>

                </div>

              </div>

            </form>



            <div className=" acciones-liquidacion">

              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="clear" onClick={handleNew} disabled={!noteditable} >Nuevo</button>
              </div>

              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="edit" onClick={handleEdit} disabled={!noteditable}>Editar</button>
              </div>
              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="grabar" onClick={handleSave} disabled={noteditable}>Guardar</button>
              </div>
              <div className="col  col-1 text-center border-info">
                <button type="button" className="filtrar" id="cancelar" onClick={handleCancel} disabled={noteditable}>Cancelar</button>
              </div>


            </div>
          </div>

        </div>


        <table className="table table-striped table-primary table-hover">

          <thead>
            <tr className="row" >
              <th className="col-1" >Código</th>
              <th className="col-3" >Variable</th>
            </tr>
          </thead>
          <tbody>
            {


              secciones.map((unolista, index) => (
                <tr key={index + '_row'} className="row" onClick={(event) => handleGoSeccion(index, event)}>
                  <td key={index + '_code'} className="col-1" >
                    {unolista.Vse_Nombre}
                  </td>
                  <td key={index + '_name'} className="col-3" >
                    {unolista.Vse_Descrip}
                  </td>

                </tr>
              )
              )
            }

          </tbody>
        </table>

      </div>

      <ToastContainer position="bottom-end">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
      </ToastContainer>










      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

          <div className="toast-body">

          </div>
        </div>
      </div>













    </div>
  );
};

export default VarSecciones;

